<template>
  <sx-flex
    class="client-entry-item"
    :gap="8"
    :isWrapping="true"
    :isBetween="true"
    :isYCentered="true"
  >
    <div class="client-entry-item__mark">
      <sx-icon size="16" name="subdir" color="currentcolor" />
    </div>
    <sx-flex :isXCentered="true" :isColumn="true">
      <sx-small color="gray"
        ><strong>{{ name }}{{ entryName && ': ' }}</strong></sx-small
      >
      <sx-small color="gray" v-if="!!entryName">{{ entryName }}</sx-small>
    </sx-flex>
    <slot />
  </sx-flex>
</template>

<script>
import SxFlex from '@/components/sx/SxFlex';
import SxSmall from '@/components/sx/SxSmall';
import SxIcon from '@/components/sx/SxIcon';

export default {
  name: 'ClientEntryItem',
  components: {
    SxFlex,
    SxIcon,
    SxSmall,
  },
  props: {
    name: {
      required: true,
      default: '',
      type: String,
    },
    entryName: {
      required: false,
      default: '',
      type: String,
    },
  },
};
</script>
<style scoped>
.client-entry-item {
  padding: 8px;

  background-color: var(--gray-0);
  border-radius: 10px;

  text-align: left !important;
}

.client-entry-item__mark {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding-left: 6px;
  min-width: 40px;
  width: 40px;

  background: linear-gradient(var(--gray-25), var(--gray-100));
  border: 1px solid var(--gray-100);
  border-radius: 8px;
  color: var(--gray-800);
}

.client-entry-item-empty__mark > div {
  position: absolute;
}
</style>
